import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import '@radix-ui/themes/styles.css'; // Import Radix UI stylesheet

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);